/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createVideoAudioInputResponseFromDiscriminatorValue, serializeCompleteUploadRequest, serializeVideoAudioInputResponse, type CompleteUploadRequest, type HttpValidationProblemDetails, type IError, type VideoAudioInputResponse } from '../../../../../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/{file-id}/revisions/{revisionId}/edit/audio/uploads/{audioInputId}/complete
 */
export interface CompleteRequestBuilder extends BaseRequestBuilder<CompleteRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<VideoAudioInputResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     post(body: CompleteUploadRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<VideoAudioInputResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CompleteUploadRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CompleteRequestBuilderUriTemplate = "{+baseurl}/files/{file%2Did}/revisions/{revisionId}/edit/audio/uploads/{audioInputId}/complete";
/**
 * Metadata for all the requests in the request builder.
 */
export const CompleteRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: CompleteRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createVideoAudioInputResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCompleteUploadRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
